import React from "react";
import styles from "./StepProgress.module.css";

/* Segmented progress bar split into discrete steps.
   - completed steps  -> dark (black) fill
   - the active step  -> theme-coloured fill
   - upcoming steps   -> light track
   `total` = number of segments, `current` = 1-based active step.
   Pass current > total (e.g. on the thank-you page) to mark everything done. */
const StepProgress = ({ total, current, label }) => (
  <div className={styles.progressWrap}>
    {label && (
      <div className={styles.progressMeta}>
        <span>{label}</span>
        <span>
          {Math.min(current, total)} / {total}
        </span>
      </div>
    )}
    <div className={styles.stepBar} role="progressbar" aria-valuenow={Math.min(current, total)} aria-valuemin={1} aria-valuemax={total}>
      {Array.from({ length: total }).map((_, i) => {
        const done = i < current - 1;
        const active = i === current - 1;
        return (
          <span
            key={i}
            className={`${styles.stepSeg} ${done ? styles.stepDone : ""} ${active ? styles.stepActive : ""}`}
          />
        );
      })}
    </div>
  </div>
);

export default StepProgress;
